/**
 * O tour não é oferecido, nem renderizado, nem avaliado em `pdv.` / `admin.`.
 *
 * Mesma exclusão (rota **e** hostname) do irmão direto `ai-idle-help.service.ts:145-151` —
 * o `app.component` já calcula `isPdv`/`isAdmin` para o menu, mas o gate do tour não os usava.
 * A travessia `app.` → `pdv.` é da Fase 4 (spec §9); até lá o tour não tem o que mostrar lá.
 * Nem na rota `/` (vazia): é o login do ERP (`appContext.loginRoute`) — #2577.
 *
 * Função pura de propósito: é o único jeito de cobrir este portão por teste sem montar o
 * harness do shell inteiro (não existe `app.component.spec.ts`).
 */
export function rotaPermiteTour(url: string, hostname: string): boolean {
  const path = (url ?? '').split('?')[0].split('#')[0];
  // 2026-10-19 (#2577): `/` é o login do ERP (e a home do site) — nada de guia ali. Depois do
  // logout o app navega para cá; sem esta linha o cartão e os balões sobreviviam na tela de login.
  if (path === '' || path === '/') return false;
  if (path.startsWith('/pdv') || path.startsWith('/admin')) return false;
  const host = hostname ?? '';
  if (host.startsWith('pdv.') || host.startsWith('admin.')) return false;
  return true;
}
